import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';
import { FeatureFlag } from "react-launch-darkly";

// Components
import * as icons from '../Icons/Icons';
import ExamDetails from '../Modules/ExamDetails';
import RequestedDates from '../Messages/RequestedDates';

const ExamCardNeedsProctor = observer(class ExamCardNeedsProctor extends React.Component {
  renderMessageButton(examSid) {
    const { translation } = this.props;

    return (
      <button
        className="btn btn--inverse--alt"
        onClick={() => {this.props.messageInstructor(examSid)}}
      >
        <icons.iconEnvelope />
        {translation.message_button}
      </button>
    )
  }

  render() {
    const { translation, exam } = this.props;
    const { userTimezone } = this.props.store.SessionStore;

    return (
      <article className="panel" aria-labelledby="exam-title-heading">
        <header className="panel__header panel__header--ready">
          <h3 id="exam-title-heading" className="panel__title">
            {exam.type.toLowerCase() === 'online' &&
              <i className="panel__icn">
                <icons.iconLaptop />
              </i>
            }

            {exam.type.toLowerCase() === 'written' &&
              <i className="panel__icn">
                <icons.iconPencilPaper />
              </i>
            }

            {exam.title}
          </h3>

          <div className="panel__tools">
            <FeatureFlag
              flagKey="message-instructor"
              renderFeatureCallback={() => this.renderMessageButton(exam.sid)}
            />
          </div>
        </header>

        <div className="panel__body">
          {
            !this.props.schedulingClosed &&
            this.props.schedulingOpen &&
            exam.examSession.examConfiguration.approved &&

            <div className="cta">
              {!this.props.showWarning &&
                <strong className="cta__copy">{translation.proctor_cta.heading}</strong>
              }

              {this.props.showWarning && Math.floor(this.props.daysLeft) >= 1 &&
                <strong className="cta__copy">
                  {
                    translation.closing_soon_cta.heading
                      .replace('%remaining%', Math.floor(this.props.daysLeft))
                  } {
                    moment.utc(this.props.scheduleCloseDate)
                      .tz(userTimezone)
                      .format('M/D/YYYY [at] h:mma z')
                  }.
                </strong>
              }

              {this.props.showWarning && Math.floor(this.props.daysLeft) <= 0 &&
                <strong className="cta__copy">
                  {
                    translation.closing_soon_cta.heading_today
                  } {
                    moment.utc(this.props.scheduleCloseDate)
                      .tz(userTimezone)
                      .format('M/D/YYYY [at] h:mma z')
                  }.
                </strong>
              }

              <Link
                className="cta__btn btn--icn-right"
                to={`schedule-session/exam/${exam.sid}/session/${exam.examSession.sid}/configuration/${exam.examSession.examConfiguration.sid}`}
              >
                {translation.proctor_cta.button}
                <icons.iconCircleRight className="icon" />
              </Link>
            </div>
          }

          {
            (
              (!this.props.schedulingOpen && !this.props.schedulingClosed) ||
              (!this.props.schedulingClosed && this.props.schedulingOpen && !exam.examSession.examConfiguration.approved)
            ) &&
            <div className="cta">
              <strong className="cta__copy">{translation.not_open_cta.heading}</strong>
            </div>
          }

          {this.props.schedulingClosed && !this.props.hasAutomated &&
            <div className="cta">
              <strong className="cta__copy">{translation.closed_cta.heading}</strong>
            </div>
          }

          {
            exam.examSession.messagingConfirmations &&
            !this.props.schedulingClosed &&
            <div>
              <h2 className="panel__heading">{translation.accepted_dates}</h2>

              {exam.examSession.messagingConfirmations.map(
                (confirmation, i) =>
                <RequestedDates
                  key={i}
                  external="true"
                  confirmedDate={confirmation.confirmedDate}
                  confirmedDateExpiration={confirmation.confirmedDateExpiration}
                  thisExamSid={exam.sid}
                  thisSessionSid={exam.examSession.sid}
                  proctor={confirmation.proctorAccountName}
                  proctorAccountLocationSid={confirmation.proctorAccountLocationSid}
                  messageSid={confirmation.sid}
                  {...this.props}
                />
              )}
            </div>
          }

          {exam.examSession.examConfiguration.approved &&
            <ExamDetails scheduleWindow={true} {...this.props} />
          }
        </div>
      </article>
    );
  }
})

export default translate('ExamCardNeedsProctor')(ExamCardNeedsProctor);



// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/ExamCardNeedsProctor.js